// import './utils/consoleGuard' // должен быть первым — перехватывает console до загрузки остальных модулей
import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import { bootApp } from './boot/initData'
import { defineSession } from './boot/defineSession'
import { setupPlugins } from './plugins'
import { setupSentry } from './plugins/sentry'
import { traceRequest } from './utils/sentryTracing'
import { perfTrace } from './utils/perfMarks'
import 'ui/styles-global'
import 'ui/c2/style'

async function main() {
  await perfTrace('bootstrap', async () => {
    const app = createApp(App)

    defineSession(store)
    if (window.prod) setupSentry(app, router, store)

    // Шаг 0: инициализация приложения (переводы, страна, /init, символы)
    await perfTrace('boot-app', () =>
      traceRequest('checkout.boot', () => bootApp(app, store))
    )
    perfTrace('plugins', () => setupPlugins(app, store))
    perfTrace('mount', () => {
      app.use(store).use(router)
      app.mount('#appCheckout')
    })
  })
}

main()
